import {
  CreditEffect,
  DowngradeEffect,
} from '@aibees/shared/features/subscription-manager/components';
import { classnames } from '@aibees/shared/utils';
import { Stack } from '@mui/material';
import { memo } from 'react';
import { Recommendation } from '../recommendation';
import { useCreditsInformation } from './hooks/use-credits-information';
import * as Styled from './styles';
import * as SX from './sx';
import type { DowngradeInformationProps as Props } from './types';

export const DowngradeInformation = memo(({ className }: Props) => {
  const crefitEffect = useCreditsInformation();

  return (
    <Styled.Wrapper
      className={classnames('DowngradeInformation', className)}
      sx={SX.root}
    >
      <Stack gap={1}>
        {crefitEffect.map(({ label, value, sx }) => (
          <CreditEffect
            key={label}
            creditAmount={value}
            label={label}
            sx={sx}
          />
        ))}
        <DowngradeEffect />
        <Recommendation />
      </Stack>
    </Styled.Wrapper>
  );
});

DowngradeInformation.displayName = 'DowngradeInformation';
